import { CMHeadingContainer, CMOffer, CMBox } from "./funds-bid.styles";
import Button, { BUTTON_TYPE_CLASSES } from "../../button/button.component";
import { useEffect, useState } from "react";
import AddFunds from "../../addFunds/addFunds.component";
import UserVerifi from "../../user-verification/user-verification.component";
import GoToVerify from "../../gotoverify/GoToVerify";

const FundsBid = ({ setActiveStep , addFunds ,handleClose ,setFundsResponse}) => {
  const [handleOpen,setHandleOpen] = useState(false);
  const [goToVerify,setGoToVerify] = useState(false);
  const [successfullTransaction,setSuccessfullTransaction] = useState(false);
  const [verificarionOpen,setVerificarionOpen] = useState(false);

  const handleAddFunds = async  () =>{
    setHandleOpen(true);
  }

  useEffect(()=>{
    if(successfullTransaction){
      setActiveStep((value)=> value +3);
      setFundsResponse(successfullTransaction);
    }
  },[successfullTransaction])

  return (
    <>
      <CMBox>
        <CMHeadingContainer>
          <h3>{addFunds}</h3>
        </CMHeadingContainer>
        <CMOffer>
          <Button
            buttonType={BUTTON_TYPE_CLASSES.BaseButton}
            color="blue"
            onClick={handleAddFunds}
          >
            Yes
          </Button>
          <Button
            buttonType={BUTTON_TYPE_CLASSES.OutlinedButton}
            color="blue"
            onClick={handleClose}
          >
            No
          </Button>
          {handleOpen &&
            <AddFunds setSuccessfullTransaction={setSuccessfullTransaction} setGoToVerify={setGoToVerify} success={true} handleOpen={handleOpen} setHandleOpen={setHandleOpen} status={"Add"} setVerificarionOpen={setVerificarionOpen}/>
          }

          {goToVerify && 
            <GoToVerify goToVerify={goToVerify} setAddFunds={setHandleOpen} setGoToVerify={setGoToVerify} setVerificarionOpen={setVerificarionOpen} />
          }

          {verificarionOpen &&
            <UserVerifi setVerificarionOpen={setVerificarionOpen} />
          }

          {verificarionOpen &&
            <UserVerifi setVerificarionOpen={setVerificarionOpen} />
          }
        </CMOffer>
      </CMBox>
    </>
  );
};
export default FundsBid;
